import React, { useEffect } from 'react'
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import useDelete from '../customHooks/useDelete';
import { toast } from 'react-toastify';
import remove from "../dist/webImages/remove.png";
import check from "../dist/webImages/check.png";




const ProductsCard = ({ data, alldata, deleted, permission }) => {
    const { id, main_image, product_title, show_on_home, stock_status, promo_status, featured, vehicle_type,catalog_title } = data

    const handleDelete = () => {
        swal({
            title: "Are you sure?",
            text: "Are you sure that you want to delete?",
            buttons: true,
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    // swal("Successfully Delete", "", "success");
                    // apiMethodDelete(`products/delete/${id}`)
                }

            });
    }
    const [resDelete, apiMethodDelete] = useDelete()
    useEffect(() => {
        if (resDelete.data) {
            const { message } = resDelete.data
            const update = alldata.filter((item) => item.id !== id)
            deleted(update)
            toast.success(message);
        }
    }, [resDelete.data])

 const check = (module, action) => permission?.[module]?.includes(action);
    return (
        <div className='ProductsCard group relative overflow-hidden rounded-[1.5rem] border border-[#D4DEF1] bg-white shadow-custom transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_35px_rgba(18,38,63,0.10)]'>
           {/* {check("Products", "Products Delete") &&  <div className='closeButton cursor-pointer absolute bg-[#FFCEDA] w-[2rem] h-[2rem] p-[.6rem] top-[.7rem] right-[.7rem] grid place-items-center rounded-[.7rem] z-10' onClick={handleDelete}>
                <svg className='w-full h-full' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863" stroke="#ED2656" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>} */}
            <Link className="ProductsCardMain flex flex-col gap-2 p-2 lg:flex-row lg:items-center" to={`/products/edit/${id}`}>
                <div className="ProductsCard__left w-full lg:w-[12rem] lg:flex-none">
                    <img src={main_image} className='h-[11rem] w-full rounded-[1.25rem] object-cover lg:h-[8rem]' alt={product_title || "product"} />
                </div>
                <div className="ProductsCard__leftRight min-w-0 flex-1">
                    <div className="mb-2 max-h-[3.1rem] overflow-hidden text-[1.1rem] capitalize font-MluvkaBold leading-[1.2] text-primary lg:text-[1.25rem]">{product_title}</div>
                    <div className='grid gap-1 text-[.88rem] text-[#475467]'>
                        <div><span className="font-MluvkaBold text-[#101828]">Catalog:</span> {catalog_title || "-"}</div>
                        <div><span className="font-MluvkaBold text-[#101828]">Vehicle Type:</span> {vehicle_type || "-"}</div>
                        <div className='flex flex-wrap gap-1 pt-2'>
                            <span className={'rounded-full px-1 pb-1 pt-0.5 leading-[1] text-[.56rem] ' + (featured ? 'bg-[#E8F7EE] text-[#12804D]' : 'bg-[#FDEBEC] text-[#C81E3A]')}>Featured</span>
                            <span className={'rounded-full px-1 pb-1 pt-0.5 leading-[1] text-[.56rem] ' + (promo_status ? 'bg-[#E8F7EE] text-[#12804D]' : 'bg-[#FDEBEC] text-[#C81E3A]')}>Promo</span>
                            <span className={'rounded-full px-1 pb-1 pt-0.5 leading-[1] text-[.56rem] ' + (stock_status ? 'bg-[#E8F7EE] text-[#12804D]' : 'bg-[#FDEBEC] text-[#C81E3A]')}>In Stock</span>
                            <span className={'rounded-full px-1 pb-1 pt-0.5 leading-[1] text-[.56rem] ' + (show_on_home ? 'bg-[#E8F7EE] text-[#12804D]' : 'bg-[#FDEBEC] text-[#C81E3A]')}>In Home</span>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row items-center justify-between gap-3 border-t border-[#EEF2F7] pt-4 lg:w-[10rem] lg:flex-col lg:items-end lg:justify-center lg:border-t-0 lg:pt-0 status-button">
                    <span className="text-sm font-MluvkaBold text-[#0F172A]">Open</span>
                    <span className="rounded-full bg-[#EFF4FD] px-4 py-2 text-sm font-MluvkaBold text-primary transition-colors group-hover:bg-primary group-hover:text-white">
                        Edit
                    </span>
                </div>
            </Link>
        </div>
    )
}

export default ProductsCard
